import $ from 'jquery';
import _ from 'underscore';
import InlineAppealView from '@bingads-webui-campaign-legacy/editorial-appeal/view/inline';
import BulkAppealEditor from '@bingads-webui-campaign-legacy/editorial-appeal/view/bulk';
import SingleAppealView from '@bingads-webui-campaign-legacy/editorial-appeal/view/single';
import { setClarityTag } from '@bingads-webui-universal/clarity';

function menuIsDisabled(grid, menu) {
  return grid.gridView ?
    $(`#${menu}`).is(':disabled') :
    grid.getMenu(menu).is(':disabled');
}

function hideinlineEditors(ids, grid) {
  if (grid) {
    _.each(ids, (id) => {
      if (grid.getExpandedRowDetail(id).is(':visible')) {
        grid.expandRowDetail(id, null, true);
      }
    });
  }
}

export default class AppealAggregator {
  constructor({
    grid,
    controller,
    submit,
    menuToFollow,
    permissions,
    requestExceptionFromPopup = false,
    instrumentation = null,
    disableAppealBtn = false,
  }) {
    this.grid = grid;
    this.controller = controller;
    this.submit = submit;
    this.menuToFollow = menuToFollow;
    this.requestExceptionFromPopup = requestExceptionFromPopup;

    this.inlineEditors = {};
    this.bulkEditor = null;
    this.permissions = permissions;
    this.instrumentation = instrumentation;
    this.disableAppealBtn = disableAppealBtn;
  }

  openInlineEditor(rowId, appealTitle) {
    hideinlineEditors(_.chain(this.inlineEditors).keys().without(rowId).value(), this.grid);

    if (this.bulkEditor) {
      this.bulkEditor.hideForm();
    }

    if (this.grid.hasExpandedRowDetail(rowId)) {
      this.grid.expandRowDetail(rowId, null, true, false);
      this.grid.cancelInlineUpdates();

      return;
    }

    const inlineEditor = new InlineAppealView({
      grid: this.grid,
      rowId,
      controller: this.controller,
      submit: this.submit,
      appealTitle,
      disableAppealBtn: menuIsDisabled(this.grid, this.menuToFollow),
      permissions: this.permissions,
    }).render();

    inlineEditor.on('success', () => {
      this.inlineEditors[rowId] = inlineEditor;
    });

    inlineEditor.on('cancel', () => {
      delete this.inlineEditors[rowId];
    });
  }

  openBulkEditor(appealTitle, el, adGroupLevelType, render = false, infoMsg, scope) {
    setClarityTag({ openBulkAppealEditor: 'true' });

    this.bulkEditor = new BulkAppealEditor({
      grid: this.grid,
      controller: this.controller,
      submit: this.submit,
      appealTitle,
      infoMsg,
      el,
      adGroupLevelType,
      isForVNext: true,
      requestExceptionFromPopup: this.requestExceptionFromPopup,
      permissions: this.permissions,
      instrumentation: this.instrumentation,
      scope,
    });

    if (render || !this.grid.gridView) {
      this.bulkEditor.render();
    }

    if (this.disableAppealBtn || menuIsDisabled(this.grid, this.menuToFollow)) {
      this.bulkEditor.disableButtons();
    }

    hideinlineEditors(_.keys(this.inlineEditors), this.grid);
  }

  openSingleEditor(id, parentId, appealTitle, infoMsg) {
    this.singleEditor = new SingleAppealView({
      id,
      parentId,
      grid: this.grid,
      controller: this.controller,
      submit: this.submit,
      appealTitle,
      infoMsg,
      permissions: this.permissions,
    });

    if ($(`#${this.menuToFollow}`).is(':disabled')) {
      this.singleEditor.disableButtons();
    }

    hideinlineEditors(_.keys(this.inlineEditors), this.grid);
  }

  resetBulkEditor() {
    if (this.bulkEditor) {
      this.bulkEditor.reset();
    }
  }

  removeBulkEditor() {
    if (this.bulkEditor) {
      this.bulkEditor.remove();
      this.bulkEditor = null;
    }
  }
}

